"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clickOutside = _interopRequireDefault(require("../ClickOutside/clickOutside"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _subComponents = require("./subComponents");

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function itemsToValues(selectedItems) {
  if (!Array.isArray(selectedItems)) return null;
  var value = selectedItems.map(function (item) {
    if (item.props.disabled) return null;
    return item.props.value || null;
  });
  value = _toConsumableArray(new Set(value)).filter(Boolean);
  return value.length > 0 ? value.join() : null;
}

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      _this.props.onChange({
        target: {
          value: itemsToValues(_this.state.selectedItems)
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      _this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          isOpen: !prevState.isOpen,
          query: ''
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clickedOutside", function () {
      var closeOnBlur = _this.props.closeOnBlur;

      if (closeOnBlur) {
        _this.closeMenu();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeMenu", function () {
      if (_this.state.isOpen) {
        _this.setState(function (prevState) {
          return _objectSpread({}, prevState, {
            isOpen: false,
            query: ''
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectItem", function (item) {
      var selectedItems = _this.state.selectedItems;
      if (!selectedItems || selectedItems.includes(item)) return;

      _this.updateSelectedItems([item]);
    });

    _defineProperty(_assertThisInitialized(_this), "onMultiSelectItem", function (item) {
      var selectedItems = _this.state.selectedItems;
      var itemIndex = selectedItems.map(function (item) {
        return item.props.value;
      }).indexOf(item.props.value);
      var newSelection;

      if (itemIndex !== -1) {
        newSelection = selectedItems.filter(function (item, index) {
          return index !== itemIndex;
        });
      } else {
        newSelection = [].concat(_toConsumableArray(selectedItems), [item]);
      }

      _this.updateSelectedItems(newSelection);
    });

    _defineProperty(_assertThisInitialized(_this), "updateSelectedItems", function (items) {
      _this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          selectedItems: items
        });
      }, _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "removeItemsFromSelected", function (items, prevSelectedItems) {
      return prevSelectedItems.filter(function (item) {
        var itemIndex = items.map(function (selectedItem) {
          return selectedItem.props.value;
        }).indexOf(item.props.value);
        return itemIndex === -1;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addItemsToSelected", function (items, prevSelectedItems) {
      return items.concat(prevSelectedItems).filter(function (elem, pos, arr) {
        return arr.indexOf(elem) === pos;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleAllItems", function (items, checked) {
      _this.setState(function (prevState) {
        var prevSelectedItems = prevState.selectedItems;
        var selectedItems;

        if ((0, _compareElementType.default)(items[0], _subComponents.DropdownOptionGroup)) {
          selectedItems = checked ? items.reduce(function (acc, group) {
            return _this.addItemsToSelected(group.props.children, acc);
          }, prevSelectedItems) : items.reduce(function (acc, group) {
            return _this.removeItemsFromSelected(group.props.children, acc);
          }, prevSelectedItems);
        } else {
          selectedItems = checked ? _this.addItemsToSelected(items, prevSelectedItems) : _this.removeItemsFromSelected(items, prevSelectedItems);
        }

        return _objectSpread({}, prevState, {
          selectedItems: selectedItems
        });
      }, _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onClearSelectionItems", function () {
      _this.setState(_objectSpread({}, _this.state, {
        selectedItems: []
      }), _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onQueryChange", function (query) {
      var saneQuery = query.trim().toLowerCase();

      _this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          query: saneQuery
        });
      });
    });

    var _selectedItems = props.multiple ? props.defaultSelectedItems : props.defaultSelectedItems.slice(0, 1);

    _this.state = {
      isOpen: props.defaultOpen,
      selectedItems: _selectedItems,
      query: ''
    };
    return _this;
  }

  _createClass(Select, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.default)(nextProps.defaultSelectedItems, this.props.defaultSelectedItems)) {
        var selectedItems = nextProps.multiple ? nextProps.defaultSelectedItems : nextProps.defaultSelectedItems.slice(0, 1);
        this.setState({
          selectedItems: selectedItems
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          query = _this$state.query,
          selectedItems = _this$state.selectedItems;
      var multiple = this.props.multiple;
      return _react.default.createElement(_clickOutside.default, {
        onClickOutside: this.clickedOutside
      }, this.props.children({
        isOpen: isOpen,
        value: itemsToValues(selectedItems),
        query: query,
        toggleMenu: this.toggleMenu,
        onClearSelectionItems: this.onClearSelectionItems,
        closeMenu: this.closeMenu,
        onSelectItem: multiple ? this.onMultiSelectItem : this.onSelectItem,
        onToggleAllItems: multiple ? this.onToggleAllItems : undefined,
        onQueryChange: this.onQueryChange
      }));
    }
  }]);

  return Select;
}(_react.default.Component);

Select.defaultProps = {
  onChange: function onChange() {},
  defaultSelectedItems: [],
  multiple: false,
  defaultOpen: false,
  closeOnBlur: true
};
Select.propTypes = {
  children: _propTypes.func.isRequired,
  defaultOpen: _propTypes.bool,
  defaultSelectedItems: _propTypes.any,
  multiple: _propTypes.bool,
  closeOnBlur: _propTypes.bool,
  onChange: _propTypes.func
};
var _default = Select;
exports.default = _default;
Select.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "toggleMenu",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "clickedOutside",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "closeMenu",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onSelectItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "item",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onMultiSelectItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "item",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateSelectedItems",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "items",
      "type": null
    }],
    "returns": null
  }, {
    "name": "removeItemsFromSelected",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "items",
      "type": null
    }, {
      "name": "prevSelectedItems",
      "type": null
    }],
    "returns": null
  }, {
    "name": "addItemsToSelected",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "items",
      "type": null
    }, {
      "name": "prevSelectedItems",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onToggleAllItems",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "items",
      "type": null
    }, {
      "name": "checked",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onClearSelectionItems",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onQueryChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "query",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Select",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "defaultSelectedItems": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "multiple": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "defaultOpen": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "closeOnBlur": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};